import { getContainer } from '@framework/di/getContainer';
import createAsyncRequest from '@/creditflowresearch/infrastructure/state/createAsyncRequest';
import ScorecardRepository from '@/creditflowresearch/infrastructure/repository/ScorecardRepository';
import actionTypes from './actionTypes';
import createAction from '@framework/state/createAction';
import { ITtmFilter } from '@/creditflowresearch/application/League/interfaces';
import { usePageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';

interface IProps {
  page: number,
  perPage: number,
  selectedPeriod: ITtmFilter,
}

export default (
  {
    page,
    perPage,
    selectedPeriod,
  }:IProps,
  dispatch,
) => {
  const container = getContainer();
  const scorecardRepository: ScorecardRepository = container.get(ScorecardRepository);
  const {
    includedRegionIds,
    includedProductIds,
  } = usePageFiltersContext();

  const getTopUnderwriters = (payload) => {
    const method = () => scorecardRepository.getTopCompaniesUnderwriter(payload);
    const request = createAsyncRequest<typeof method>({
      dispatch,
      method,
      types: [
        actionTypes.GET_COLLECTION,
        actionTypes.GET_COLLECTION_SUCCESS,
        actionTypes.GET_COLLECTION_ERROR,
      ],
    });

    return request();
  };

  const paginateTopUnderwriters = (payload) => dispatch(createAction(actionTypes.PAGINATE, payload));
  const resetTopUnderwriters = () => dispatch(createAction(actionTypes.RESET));
  const setTopUnderwritersData = (payload) => dispatch(createAction(actionTypes.GET_COLLECTION_SUCCESS, payload));

  const getTopUnderwritersByFilter = () => {
    const payload = {
      page,
      perPage,
      filters: {
        dateFrom: selectedPeriod.dateFrom,
        dateTo: selectedPeriod.dateTo,
        includedProductIds,
        includedRegionIds,
      },
    };

    getTopUnderwriters(payload);
  };

  return {
    paginateTopUnderwriters,
    resetTopUnderwriters,
    getTopUnderwritersByFilter,
    setTopUnderwritersData,
  };
};
